module.exports = __webpack_public_path__ + "static/media/login_image.3f0e9c2d.png";